import { trackEvent } from 'shared/helpers/Analytics';

type LoginAnalyticsEvent =
  | { name: 'CTMS: Clicked Forgot Password' }
  | { name: 'CTMS: Clicked Reset Password' }
  | { name: 'CTMS: Opened New Login Page' }
  | { name: 'CTMS: Clicked Contact Support' }
  | { name: 'CTMS: Clicked "I didn\'t receive the email" link' }
  | { name: 'CTMS: Clicked Back to Forgot Password' }
  | {
      name: 'CTMS: Attempted to Login with Driver Email';
      isInvalidRole?: boolean;
    }
  | { name: 'CTMS: Clicked Sign Up' }
  | { name: 'CTMS: Reset Password Success via Email' }
  | { name: 'CTMS: Logged in Successfully' }
  | { name: 'CTMS: Verified Account Successfully'; channel: string };

export function trackLoginEvent(event: LoginAnalyticsEvent) {
  const { name, ...props } = event;

  trackEvent(name, { ...props });
}
